import { render, staticRenderFns } from "./rules-view.vue?vue&type=template&id=3ab6bf10&"
import script from "./rules-view.vue?vue&type=script&lang=js&"
export * from "./rules-view.vue?vue&type=script&lang=js&"
import style0 from "./rules-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports